import { fetchJSON as fetchAPI } from './client';

const RUNTIME_BASE = import.meta.env.VITE_RUNTIME_API ?? 'http://localhost:8159';

export type ExceptionStatus = {
  id: string;
  description: string;
  closed: boolean;
  evidence?: string;
};

export type PlatformProbe = {
  name: string;
  url: string;
  healthy: boolean;
  latency?: string;
};

export type MigrationVerifyReport = {
  total: number;
  verified: number;
  missing: number;
  complete: boolean;
};

export type PerformanceBaselines = {
  saga_start_ms: number;
  dlq_route_ms: number;
  outbox_claim_ms: number;
  api_health_ms: number;
  slo_met: boolean;
};

export type LiveCertificationReport = {
  generated_at: string;
  exceptions: ExceptionStatus[];
  all_closed: boolean;
  measured_coverage: number;
  coverage_gate_met: boolean;
  platform_probes: PlatformProbe[];
  migration_verify: MigrationVerifyReport;
  performance_baselines: PerformanceBaselines;
  certification_ready: boolean;
};

function fetchRuntime<T>(path: string, init?: RequestInit): Promise<T> {
  return fetchAPI<T>(RUNTIME_BASE, path, init);
}

export const certificationApi = {
  live: () => fetchRuntime<LiveCertificationReport>('/api/v1/certification/live'),
  exceptions: () => fetchRuntime<{ exceptions: ExceptionStatus[] }>('/api/v1/certification/exceptions'),
  coverage: () => fetchRuntime<{ measured_coverage: number; gate_met: boolean }>('/api/v1/certification/coverage'),
  performance: () => fetchRuntime<PerformanceBaselines>('/api/v1/certification/performance'),
};
